import React, { useEffect, useMemo, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { Bounce } from "react-reveal";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import flagimg from "../../../assets/United Arab Emirates.png";
import noimage from "../../../assets/noimage1.png";
import RaceSectionTimer from "../../Reuseable/RaceSectionTimer";
import { useSelector } from "react-redux";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const RaceCourseAccordionItem = React.memo(function RaceCourseAccordionItem({
  raceCourseRecord,
  cookiedata,
  eventKey,
  onHeaderClick,
  onRaceClick,
}) {
  const raceCourse = raceCourseRecord?.RacesOfAllRaceCourseAnnuall;
  const raceData = raceCourseRecord?.RacesData || [];

  const trackTitle =
    cookiedata === "en" ? raceCourse?.TrackNameEn : raceCourse?.TrackNameAr;

  const displayDate =
    raceData.length > 0
      ? moment(raceData[0].StartTime).format("dddd, DD MMMM YYYY")
      : "Date not available";

  const groupedByRaceName = useMemo(() => {
    const grouped = {};

    raceData.forEach((race) => {
      const raceName =
        cookiedata === "en"
          ? race?.RaceNameModelData?.NameEn || "Race"
          : race?.RaceNameModelData?.NameAr || "سباق";
      const year = moment(race?.StartTime).format("YYYY");

      if (!grouped[raceName]) grouped[raceName] = {};
      if (!grouped[raceName][year]) grouped[raceName][year] = [];
      grouped[raceName][year].push(race);
    });

    return grouped;
  }, [raceData, cookiedata]);

  return (
    <Accordion.Item
      key={raceCourse?._id || eventKey}
      eventKey={eventKey}
      className="track-item"
    >
      <Accordion.Header className="track-header" onClick={onHeaderClick}>
        <span className="track-title">{trackTitle}</span>
        <span className="track-subtitle">{displayDate}</span>
        <div
          className="track-accent-bar"
          style={{
            background: raceCourse?.ColorCodeData?.Color || "#1e75e6",
          }}
        />
      </Accordion.Header>

      <Accordion.Body>
        <Accordion>
          {Object.entries(groupedByRaceName).map(([raceName, years], raceIndex) => (
            <Accordion.Item
              eventKey={`${eventKey}-race-${raceIndex}`}
              key={`${raceCourse?._id || eventKey}-race-${raceIndex}`}
              className="race-name-item"
            >
              <Accordion.Header className="race-name-header">
                {raceName}
              </Accordion.Header>
              <Accordion.Body>
                <Accordion>
                  {Object.entries(years)
                    .sort(([a], [b]) => Number(b) - Number(a))
                    .map(([year, races], yearIndex) => {
                      const sortedRaces = [...races].sort((a, b) => {
                        const ta = new Date(a?.StartTime).getTime();
                        const tb = new Date(b?.StartTime).getTime();
                        if (ta !== tb) return ta - tb;
                        return (a?.RaceNumber || 0) - (b?.RaceNumber || 0);
                      });

                      return (
                        <Accordion.Item
                          eventKey={`${eventKey}-year-${yearIndex}`}
                          key={`${raceCourse?._id || eventKey}-race-${raceIndex}-year-${year}`}
                          className="year-item"
                        >
                          <Accordion.Header className="year-header">
                            <div className="top-space">{year}</div>
                          </Accordion.Header>
                          <Accordion.Body>
                            {sortedRaces.map((race, i) => (
                              <div
                                key={race?._id || i}
                                className="race-card-inner"
                                onClick={() => onRaceClick(race?._id)}
                              >
                                <p style={{ fontWeight: "500" }}>{raceName}</p>
                                <p style={{ fontWeight: "700" }}>
                                  Race No : {race?.RaceNumber}
                                </p>
                                <p>
                                  {moment(race?.StartTime).format("DD-MM-YYYY")}
                                </p>
                              </div>
                            ))}
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })}
                </Accordion>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Accordion.Body>
    </Accordion.Item>
  );
});

const AntePost = ({ AntePostRaces }) => {
  const navigate = useNavigate();
  const [userIsDesktop, setUserIsDesktop] = useState(true);
  const { data: ThemeSetting } = useSelector((state) => state.ThemeSetting);
  const { t } = useTranslation();

  useEffect(() => {
    setUserIsDesktop(window.innerWidth > 840);
  }, []);

  const location = useLocation();
  const cookiedata = Cookies.get("i18next") || "en";

  function HandleJockey(id) {
    navigate(`/race-detail?${id}`);
  }

  function HandleCard(cardid) {
    // Logic preserved
  }

  return (
    <div className="ante-post-ui-wrapper">
      <style>{`
        .ante-post-ui-wrapper {
            background-color: transparent;
            padding: 5px;
            color: white;
        }
         .ante-post-ui-wrapper .track-item {
            background-color: #0d1633 !important;
            border: none !important;
            margin-bottom: 18px;
            border-radius: 18px !important;
            overflow: hidden;
            border-bottom: 1px solid rgba(255,255,255,0.05) !important;
        }
        .ante-post-ui-wrapper .track-header .accordion-button {
            background-color: #143067 !important;
            color: white !important;
            padding: 18px 15px !important;
            box-shadow: none !important;
            display: flex !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            position: relative;
        }
        @media (min-width: 375px) and (max-width: 1024px){
        .ante-post-ui-wrapper .track-header .accordion-button{
          padding: 8px 14px !important;
          }  
        }  
        .ante-post-ui-wrapper .track-header .accordion-button::after {
          filter: invert(1); 
          position: absolute;
          right: 20px;
          top: 40%;
        }
        .ante-post-ui-wrapper .track-title {
            font-size: 22px;
            font-weight: 700;
            margin: 0;
            display: block;
            width: 100%;
            text-align: left;
        }
        .ante-post-ui-wrapper .track-subtitle {
            font-size: 13px;
            color: #b0b0b0;
            margin-top: 4px;
            margin-bottom: 4px;
            display: block;
        }
        .ante-post-ui-wrapper .track-accent-bar {
            height: 5px;
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
        }
        .ante-post-ui-wrapper .race-name-item {
            border: none !important;
            background: transparent !important;
            margin-bottom: 8px;
        }
        .ante-post-ui-wrapper .race-name-header .accordion-button {
            background-color: #1e75e6 !important;
            color: white !important;
            border-radius: 8px !important;
            padding: 12px 15px !important;
            font-weight: 500;
            font-size: 16px;
        }
        .ante-post-ui-wrapper .year-item {
            background-color: #1c3275 !important;
            border: 1px solid #3b5cbd !important;
            border-radius: 8px !important;
            padding-bottom: 1rem;
        }
        .ante-post-ui-wrapper .year-header .accordion-button {
            background-color: transparent !important;
            color: white !important;
            font-size: 18px;
            box-shadow: none !important;
            padding-bottom: 0;
            padding-left: 10px;
        }
        .ante-post-ui-wrapper .year-header .accordion-button::after {
            content: '-' !important;
            background: none !important;
            font-size: 24px;
            font-weight: bold;
            transform: none !important;
            display: flex;
            align-items: center;
            justify-content: center;
        }        
        .ante-post-ui-wrapper .year-header .accordion-button.collapsed::after {
            content: '+' !important;
        }

        .ante-post-ui-wrapper .race-card-inner {
            background-color: #19469d;
            border: 1px solid #3b5cbd;
            border-radius: 10px;
            padding: 12px;
            cursor: pointer;
            transition: 0.2s;
            color:white;
        }

        .ante-post-ui-wrapper .race-card-inner p {
            margin-bottom: 3px;
            font-size: 15px;
        }

        .ante-post-ui-wrapper .CompetitionData{
        overflow: hidden !important;
        }

      

        /* Common Accordion Fixes */
        .ante-post-ui-wrapper .accordion-item { border: none; }
        .ante-post-ui-wrapper .accordion-body { padding: 10px !important; background: transparent !important; padding-top:0 !important }
      `}</style>

      <Bounce bottom>
        <div className="Currentpostdiv">
          {!AntePostRaces || AntePostRaces.length === 0 ? (
            <SkeletonTheme baseColor="#0d1633" highlightColor="#1c3275">
              <div style={{ padding: "10px" }}>
                <Skeleton
                  height={80}
                  count={5}
                  style={{ marginBottom: "15px", borderRadius: "12px" }}
                />
              </div>
            </SkeletonTheme>
          ) : (
            <div className="CompetitionData">
              <Accordion>
                {AntePostRaces.map((countryRecord, countryIndex) => {
                  const countryName =
                    cookiedata === "en"
                      ? countryRecord?.Country?.NameEn
                      : countryRecord?.Country?.NameAr;
                  const raceCourses = countryRecord?.RaceCourses || [];

                  return (
                    <Accordion.Item
                      key={countryRecord?.Country?._id || countryIndex}
                      eventKey={`country-${countryIndex}`}
                      className="track-item"
                    >
                      <Accordion.Header className="track-header">
                        <span className="track-title">
                          {countryName || (cookiedata === "en" ? "Country" : "بلد")}
                        </span>
                        <span className="track-subtitle">
                          {(cookiedata === "en" ? "Racecourses" : "ميادين") +
                            `: ${raceCourses.length}`}
                        </span>
                        <div
                          className="track-accent-bar"
                          style={{
                            background: "#1e75e6",
                          }}
                        />
                      </Accordion.Header>

                      <Accordion.Body>
                        <Accordion>
                          {raceCourses.map((raceCourseRecord, rcIndex) => {
                            return (
                              <RaceCourseAccordionItem
                                key={
                                  raceCourseRecord?.RacesOfAllRaceCourseAnnuall?._id ||
                                  `rc-${countryIndex}-${rcIndex}`
                                }
                                raceCourseRecord={raceCourseRecord}
                                cookiedata={cookiedata}
                                eventKey={`rc-${countryIndex}-${rcIndex}`}
                                onHeaderClick={() => HandleCard(raceCourseRecord)}
                                onRaceClick={(raceId) => HandleJockey(raceId)}
                              />
                            );
                          })}
                        </Accordion>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            </div>
          )}
        </div>
      </Bounce>
    </div>
  );
};

export default AntePost;
